import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/@services/common.service";
import { FormService } from "src/@services/form.service";
import { CommonResponseRecords, FieldId } from "src/models/commomnModel.model";
import { Program } from "src/models/program.model";
import { CommonPagesService } from "../../common-pages.service";
import { responseMessageStatus, ResponseStatus } from "../../enum";

@Component({
  selector: "app-add-update-program",
  templateUrl: "./add-update-program.component.html",
  styleUrls: ["./add-update-program.component.scss"],
  standalone: false,
})
export class AddUpdateProgramComponent implements OnInit {
  //#region properties
  isVisibleUserDrawer = true;
  userDrawerTitle: string;
  @Output() hideProgramDrawer = new EventEmitter();
  @Input() selectedData: Program;
  isLoadingUser: boolean = false;
  showAccountsInvalidMessage: boolean = false;
  showSitesInvalidMessage: boolean = false;
  descriptionToShow: string = "";
  listOfMonths: string[] = [];
  listOfYears: number[] = [];
  listOfEndYears: number[] = [];
  siteId: string = "";
  id: string;
  @ViewChildren("proStartMonth") proStartMonth: FieldId;
  @ViewChildren("proStartYear") proStartYear: FieldId;
  @ViewChildren("proEndMonth") proEndMonth: FieldId;
  @ViewChildren("proEndYear") proEndYear: FieldId;
  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private route: ActivatedRoute
  ) {
    _fS.programForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    //get site id for URL
    this.siteId = this.route.snapshot.paramMap.get("siteId");
    this.listOfMonths = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 2;
    for (let index = 2016; index <= maxYear; index++) {
      this.listOfYears.push(index);
    }
    this.listOfEndYears = this.listOfYears;
    //while edit change modal title
    if (this.selectedData != null) {
      this.userDrawerTitle = "Edit Program Period";
      this._fS.programForm.patchValue({
        label: this.selectedData.label,
        startMonth: this.selectedData.startMonth,
        startYear: this.selectedData.startYear,
        endMonth: this.selectedData.endMonth,
        endYear: this.selectedData.endYear,
        isVisible: this.selectedData.isVisible,
      });

      this.listOfEndYears = this.listOfYears.filter(
        (year) => year >= parseInt(this.selectedData.startYear)
      );

      if (this.selectedData.isDefault) {
        this._fS.programForm.get("isVisible").disable();
      }
    } else {
      this.userDrawerTitle = "Add Program Period";
    }
  }

  //close drawer
  handleCancel() {
    this.isVisibleUserDrawer = false;
    this.hideProgramDrawer.emit({ hide: this.isVisibleUserDrawer, data: null });
  }

  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.programForm.valid) {
      this.isLoadingUser = true;
      const formValue = this._fS.programForm.value;
      const programBody: any = {
        id: this.selectedData == null ? null : this.selectedData.id,
        label: formValue.label,
        startMonth: formValue.startMonth,
        endMonth: formValue.endMonth,
        startYear: parseInt(formValue.startYear),
        endYear: parseInt(formValue.endYear),
        isVisible:
          this.selectedData && this.selectedData.isDefault
            ? this.selectedData.isVisible
            : formValue.isVisible,
        isDefault: this.selectedData ? this.selectedData.isDefault : false,
        siteId: this.siteId,
        linked: this.selectedData ? this.selectedData.linked : 0,
      };
      //add or edit user data
      this.selectedData == null
        ? this.addProgramData(programBody)
        : this.editProgramData(programBody);
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.programForm);
    }
  }

  editProgramData(programBody: Program) {
    this._cpS
      .updateProgram(programBody)
      .subscribe((response: CommonResponseRecords<Program>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          //hide unit drawer
          this.isLoadingUser = false;
          this.isVisibleUserDrawer = false;
          this.hideProgramDrawer.emit({
            hide: this.isVisibleUserDrawer,
            data: response.result,
          });
        } else {
          this.isLoadingUser = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  //add or update date on buttton click
  addProgramData(programBody: Program) {
    this._cpS
      .addProgram(programBody)
      .subscribe((response: CommonResponseRecords<Program>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          //hide program drawer
          this.isLoadingUser = false;
          this.isVisibleUserDrawer = false;
          this.hideProgramDrawer.emit({
            hide: this.isVisibleUserDrawer,
            data: response.result,
          });
        } else {
          this.isLoadingUser = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  focusProStartYear(event: FieldId) {
    if (event) {
      this.proStartYear.first.focus();
    }
  }
  focusProEndYear(event: FieldId) {
    if (event) {
      this.proEndYear.first.focus();
    }
  }
  onSelectStartYear(selectedYear: number) {
    if (selectedYear) {
      this.proEndMonth.first.focus();
    }
    this._fS.programForm.patchValue({
      endYear: "",
    });
    this.listOfEndYears = this.listOfYears.filter(
      (year) => year >= selectedYear
    );
  }
  //#endregion
}
